import { render } from "./LocationSliders.vue?vue&type=template&id=63fa1dba"
import script from "./LocationSliders.vue?vue&type=script&lang=js"
export * from "./LocationSliders.vue?vue&type=script&lang=js"

import "./LocationSliders.vue?vue&type=style&index=0&id=63fa1dba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__